import { BCMSRecord, DisabledPrompt, Link, useBCMSContext } from "@bcm-dev/bcms-vite";
import EDEStatementsPageContainer from "components/EDEStatements/shared/containers/EDEStatementsPageContainer";
import EDEStatementsPageContentView from "components/EDEStatements/shared/views/EDEStatementsPageContentView";
import { CenterContentContainer, ContentHeaderView, TableBody, TableColumnContainer, TableColumnView, TableView } from 'components/shared';
import Classes from "model";
import React from "react";
import "./styles.css";
import "./mobile.css";


/**
 * @function EDEOthersStatementsPage
 * @return {React.Component}
 * @exported true
 * @description The ede "Other's Statemens" page.
 */
export default function EDEOthersStatementsPage(props) {
  // Initalize all model classes
  const context = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, context);

  // Sets the values for the data and ui variables
  const data = { ...getDefaultPageData(), ...props.data ?? {} };
  const ui = { ...getDefaultPageUI(), ...props.ui ?? {} };
  // The state to be passed to the state manager
  const state = { data, ui };
  
  // :: React.state, React.setState -> OBJECT
  // Function to initalize the controller for the state manager
  const controller = (state, setState) => ({
      data: state.data, // Set the data property of the controller
      ui: state.ui, // Set the ui property of the controller
      
  });
  
  return(
    <EDEStatementsPageContainer className={ `ede-others-statements-page` } state={ state } controller={ controller }>
        <PageContent/>
    </EDEStatementsPageContainer>
  );
}

/**
 * @name getDefaultPageData
 * @param {Void} 
 * @returns {OBJECT}
 * @description Hook to return the default data required by the page
 */
export const getDefaultPageData = () => {

  return {}
};

/**
* @name getDefaultPageUI
* @param {Void} 
* @return {OBJECT}
* @description Hook to return the default ui required by the page.
*/
export const getDefaultPageUI = () => ({
  // no ui changes for now
  
});

function PageContent(props) {
  const subheader = `Enter your invitation code to register and view other's statements.`;

  return (
    <EDEStatementsPageContentView>
      <div className="ede-others-statements-page-container flex-container flex-vertical flex-width">
        <CenterContentContainer>
          <ContentHeaderView text="Other's Statements" />
          <p className="subheader">{ subheader }</p>
          <TableView className="ede-others-statements-table">
              <TableColumnContainer>
                  <TableColumnView className="text-left date" text={ "Access" } />
                  <TableColumnView className="text-left description" text={ "Name" } />
                  <TableColumnView className="actions-column" text={ "Email" } />
              </TableColumnContainer>
              <TableBody>
                  { undefined }
                  <tr>
                    <td className="text-center table-item-view" colSpan="3"></td>
                  </tr>
                  <tr>
                    <td className="text-center table-item-view" colSpan="3"></td>
                  </tr>
              </TableBody>
              
          </TableView>
          <DisabledPrompt>
            <Link>Add Access</Link>
          </DisabledPrompt>
        </CenterContentContainer>
      </div>
    </EDEStatementsPageContentView>
  );
}
